/**
 * @param {string} title
 * @returns {import('@/features/documentPreview/documentPreviewTypes.js').HtmlPreviewPayload}
 */
export function buildDemoHtmlAppPayload(title) {
  const safeTitle = title.replace(/[<>&]/g, '')
  return {
    html: `<!DOCTYPE html><html><head><meta charset="utf-8"><style>
body{font-family:system-ui,sans-serif;margin:0;color:#272727;background:#fafbfc}
.hero{padding:48px 32px;background:linear-gradient(135deg,#f4f7fb,#e9eff6)}
h1{margin:0 0 12px;font-size:1.75rem;font-weight:600}
p{margin:0;line-height:1.5;color:#424242;max-width:52ch}
.card{background:#fff;border:1px solid #e8ded6;border-radius:12px;padding:20px;margin:32px}
</style></head><body>
<div class="hero"><h1>${safeTitle}</h1><p>AI-generated preview — replace with live HTML from your agent.</p></div>
<div class="card"><strong>Feature highlight</strong><p>Interactive UI will render here when generation is connected.</p></div>
</body></html>`,
  }
}
